import CalendarEventsAPI from '../../api/calendarEvents';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isSaving: false,
    isDeleting: false,
  },
};

const sortEvents = events =>
  [...events].sort((a, b) => new Date(a.starts_at) - new Date(b.starts_at));

const upsertEvent = (events, event) => {
  const index = events.findIndex(item => item.id === event.id);
  if (index === -1) {
    events.push(event);
  } else {
    events.splice(index, 1, { ...events[index], ...event });
  }

  return sortEvents(events);
};

export const getters = {
  getEvents($state) {
    return $state.records;
  },
  getEventById: $state => eventId => {
    return $state.records.find(event => event.id === Number(eventId)) || null;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  fetchEvents: async ({ commit }, range) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await CalendarEventsAPI.getEvents(range);
      commit('setEvents', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
  createEvent: async ({ commit }, payload) => {
    commit('setUIFlag', { isSaving: true });
    try {
      const response = await CalendarEventsAPI.createEvent(payload);
      commit('upsertEvent', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  updateEvent: async ({ commit }, { eventId, payload }) => {
    commit('setUIFlag', { isSaving: true });
    try {
      const response = await CalendarEventsAPI.updateEvent(eventId, payload);
      commit('upsertEvent', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  deleteEvent: async ({ commit }, eventId) => {
    commit('setUIFlag', { isDeleting: true });
    try {
      await CalendarEventsAPI.deleteEvent(eventId);
      commit('removeEvent', eventId);
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  setEvents($state, events) {
    $state.records = sortEvents(events || []);
  },
  upsertEvent($state, event) {
    $state.records = upsertEvent($state.records, event);
  },
  removeEvent($state, eventId) {
    const normalizedEventId = Number(eventId);
    $state.records = $state.records.filter(
      event => event.id !== normalizedEventId
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
